import { SelectOption } from '@/components/elements/select'

export const placeMap: SelectOption[] = [
	{
		label:
			'Gimnasio Sportcenter - C.C. 8A, Calle 8, 2da planta, Chinchiná, Caldas',
		value:
			'Gimnasio Sportcenter - C.C. 8A, Calle 8, 2da planta, Chinchiná, Caldas',
	},
	{
		label: 'Virtual por el medio elegido por el usuario',
		value: 'Virtual por el medio elegido por el usuario',
	},
	{
		label: 'Presencial/Virtual - Sportcenter o medio elegido',
		value: 'Presencial/Virtual - Sportcenter o medio elegido',
	},
]
